import React from "react";
import { Button, Grid, Paper } from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';

export const SearchRecommendations = ({
  onClick,
}: {
  onClick: (value: string) => void;
}) => {
  // Add your recommendations here
  const Reccomendation = [
    "Can you give an overview of patent applications for CD19-targeting CAR-T therapies?",
    "Which patented drugs target CD30 for Hodgkin’s lymphoma?",
  ];
  const isMobile = useMediaQuery('(min-width:768px)');
  return (
    <Grid
      columns={5}
      style={{ width: "100%" }}
      container
      columnGap={"20px"}
      rowGap={"20px"}
      justifyContent={"space-between"}
      
    >
      {Reccomendation.map((rec) => (
       <Grid item xs={12} md={2}  style={{
        maxWidth: isMobile ? '47%' : 'auto',
        flexBasis: isMobile ? '47%' : 'auto',
      }}>
          <Button onClick={() => onClick(rec)} sx={{ padding: "20px", borderRadius: "20px", height: '100%' }} variant='outlined' fullWidth>
              {rec}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

// import React from "react";
// import { Button, Grid } from "@mui/material";
// import useMediaQuery from '@mui/material/useMediaQuery';

// export const SearchRecommendations = ({
//   onClick,
// }: {
//   onClick: (value: string) => void;
// }) => {
//   // Add your recommendations here
//   const Reccomendation = [
//     "Can you give an overview of patent applications for CD19-targeting CAR-T therapies?",
//     "Which patented drugs target CD30 for Hodgkin’s lymphoma?",
//   ];
  
//   const isMobile = useMediaQuery('(min-width:768px)');
  
//   return (
//     <Grid
//       container
//       spacing={3} // A better way to set spacing between Grid items
//       justifyContent={"space-between"}
//     >
//       {Reccomendation.map((rec, index) => (
//         <Grid 
//           item 
//           key={index} // Unique key prop added here
//           xs={12} 
//           md={2}  
//           style={{
//             maxWidth: isMobile ? '47%' : 'auto',
//             flexBasis: isMobile ? '47%' : 'auto',
//           }}
//         >
//           <Button onClick={() => onClick(rec)} sx={{ padding: "20px", borderRadius: "20px", height: '100%' }} variant='outlined' fullWidth>
//             {rec}
//           </Button>
//         </Grid>
//       ))}
//     </Grid>
//   );
// };

